!(function () {
    "use strict";
    const e = "[data-grid-item]",
        t = "hidden",
        i = "grid--slider";
    customElements.get("related-products") ||
        customElements.define(
            "related-products",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.sectionId = this.id),
                        (this.relatedItems = 0),
                        (this.wrapper = this.querySelector("[data-recently-viewed-wrapper]")),
                        (this.recentlyViewed = this.querySelector("recently-viewed"));
                }
                connectedCallback() {
                    this.loadRelatedProducts(), this.loadRecentlyViewedProducts();
                }
                loadRelatedProducts() {
                    const e = this.querySelector("[data-related-section]");
                    if (!e) return;
                    const t = e.getAttribute("data-product-id"),
                        i = e.getAttribute("data-limit"),
                        s = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${t}&intent=related`;
                    fetch(s)
                        .then((e) => e.text())
                        .then((t) => this.handleRelatedProductsResponse(t, e))
                        .catch(() => this.hideSection(e));
                    setTimeout(function(){
                        if(typeof window.iWish!=='undefined'){
                                window.iWish.checkIwishColl();
                          }
                     },3500);
                }
                handleRelatedProductsResponse(t, s) {
                    const r = document.createElement("div");
                    r.innerHTML = new DOMParser()
                        .parseFromString(t, "text/html")
                        .querySelector("[data-api-related-template]").innerHTML;
                    const d = r.querySelectorAll(e).length;
                    if (d > 0) {
                        (s.innerHTML = r.innerHTML), (this.relatedItems = d);
                        const t = parseInt(s.style.getPropertyValue("--COLUMNS-MOBILE")),
                            n = s.querySelector(e);
                        0 === t && n.parentElement.classList.add("grid--mobile-slider"),
                            "slider" === s.getAttribute("data-layout")
                                ? n.parentElement.classList.add(i)
                                : n.parentElement.classList.remove(i);
                    } else this.hideSection(s);
                    this.updateVisibility();
                }
                loadRecentlyViewedProducts() {
                    this.recentlyViewed.addEventListener("theme:recently-viewed:loaded", () => {
                        this.handleRecentlyViewedResponse();
                    });
                }
                handleRecentlyViewedResponse() {
                    const e = parseInt(this.recentlyViewed.dataset.minimum) || 1,
                        i = this.recentlyViewed.querySelectorAll(".product-item"),
                        s = this.recentlyViewed.querySelector("grid-slider"),
                        r = !this.wrapper && i.length > 0,
                        d = this.wrapper && i.length >= e;
                    (r || d) &&
                        (d && this.wrapper.classList.remove(t),
                        this.recentlyViewed.classList.remove(t),
                        this.recentlyViewed.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: !0 })),
                        s && s.dispatchEvent(new CustomEvent("theme:grid-slider:init", { bubbles: !0 }))),
                        this.updateVisibility();
                     setTimeout(function(){
                        if(typeof window.iWish!=='undefined'){
                            console.log('recently')
                                window.iWish.checkIwishColl();
                          }
                     },3000);
                }
                hideSection(e) {
                    e.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
                }
                updateVisibility() {
                    const e = Shopify.Products.getConfig().howManyToShow < 1 && this.relatedItems < 1;
                    this.classList.toggle(t, e);
                }
            }
        );
})();
